import queryFeatureAccessSettings from '@ms/yammer-graphql/dist/operations/queryFeatureAccessSettings.graphql';

const apiName = 'FeatureAccessSettingsClients';

const apiRequestBody = {
  operationName: apiName,
  query: queryFeatureAccessSettings,
};

export const getCacheKey = (): string => apiName.concat(JSON.stringify(apiRequestBody));
